import $ from 'jquery';

export default class OfferRequestCreate {
  constructor($scope, OfferRequestService, UserService) {
    $scope.set_supplier_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Seller', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.offer_request.supplier_id = ui.item.id;
          $scope.supplier_company = ui.item.value;
          $scope.$apply();
        }
      });
    };

    $scope.set_buyer_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Buyer', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.offer_request.buyer_id = ui.item.id;
          $scope.buyer_company = ui.item.value;
          $scope.$apply();
        }
      });
    };

    $scope.create = function() {
      if (!($scope.offer_request.title && $scope.offer_request.supplier_id && $scope.offer_request.buyer_id)) {
        $scope.form_error = 'Please complete all fields!';
      } else {
        $scope.creating = true;
        OfferRequestService.create($scope.offer_request).success(function(data) {
          if (data.success) {
            $scope.creating = false;
            window.location = '/admin/marketplace/offer_requests';
          } else {
            $scope.form_error = data.message;
          }
        });
      }
    };

    $scope.offer_request = {
      id: null,
      title: null,
      supplier_id: null,
      buyer_id: null,
      status: 1
    };

    $scope.init = function() {
      $scope.set_supplier_autocomplete($('input.supplier_company'));
      $scope.set_buyer_autocomplete($('input.buyer_company'));
      $scope.status_options = OfferRequestService.get_status_options();
    };

    $scope.init();
  }
}

OfferRequestCreate.$inject = ['$scope', 'OfferRequestService', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-request-create.ctrl.js